import { RightCircleOutlined } from "@ant-design/icons";
import { FloatButton, Tooltip } from "antd";
import { useNextStep } from "../contexts/NextStepContext";
import styles from "./NextViewButton.module.css";

const NextViewButton = () => {
    const { visible, canProceed, activate } = useNextStep();

    return (
        <Tooltip
            title={
                canProceed
                    ? "Continue"
                    : "Finish this step to continue"
            }
        >
            <FloatButton
                type="primary"
                className={styles.pulsingFloat}
                style={{
                    insetInlineEnd: 24,
                    visibility: visible ? "visible" : "hidden"
                }}
                aria-label="Continue"
                disabled={!canProceed}
                icon={<RightCircleOutlined />}
                onClick={activate}
            />
        </Tooltip>
    );
};

export default NextViewButton;
